
export default {
    settings: {
        userType: null
    },
    persistKeys: ['tabs']
}
